import { jsxs, jsx } from "react/jsx-runtime";
import { styled } from "@mui/material";
import { useAnimation, motion } from "motion/react";
import { useRef, useState, useEffect } from "react";
import { useStateWithDep } from "../../utils/hooks/useStateWithDep.js";
import { WIDGET_MEDIA_BORDER_RADIUS } from "../../utils/constants/Constants.js";
const VideoContainer = styled(motion.div)({
  position: "relative",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  overflow: "hidden",
  maxHeight: "inherit",
  width: "100%",
  height: "100%",
  ".video_control": {
    position: "absolute",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1,
    width: "100%",
    height: "100%",
    "&.lower": {
      alignItems: "flex-end",
      justifyContent: "flex-start",
      padding: "20px",
      ".control_button": {
        width: "25%"
      }
    },
    cursor: "pointer",
    ".control_button": {
      background: "none",
      outline: "none",
      border: "none",
      opacity: 0,
      transition: "opacity 500ms",
      width: "23%",
      maxWidth: 100,
      cursor: "pointer",
      ".play_button": {
        height: "100%",
        width: "100%"
      },
      ".pause_button": {
        height: "100%",
        width: "100%"
      }
    },
    "&.playing": {
      ".control_button": {
        opacity: "0 !important"
      }
    },
    "&.paused": {
      ".control_button": {
        opacity: "1 !important"
      }
    }
  },
  ".video_content": {
    objectFit: "contain",
    borderRadius: WIDGET_MEDIA_BORDER_RADIUS,
    maxHeight: "100%",
    maxWidth: "100%"
  },
  "video[poster]": {
    maxHeight: "100%",
    maxWidth: "100%",
    width: "100%",
    height: "100%"
  }
});
const BrandclubVideo = ({
  fixContainer = false,
  videoUrl,
  posterUrl,
  canPlay = true,
  lowerPlaybutton = false,
  onPlay = () => ({}),
  onPause = () => ({}),
  onEnd = () => ({})
}) => {
  const videoRef = useRef(null);
  const [playing, setPlaying] = useState(false);
  const [videoLink, setVideoLink] = useState("");
  const [posterLink, setPosterLink] = useStateWithDep(posterUrl);
  useEffect(() => {
    if (!canPlay) {
      pauseVideo();
    }
  }, [canPlay]);
  const controls = useAnimation();
  useEffect(() => {
    pauseVideo();
    videoSwitchAnimation();
  }, [videoUrl]);
  const videoSwitchAnimation = async () => {
    if (canPlay && videoLink) {
      await controls.start({
        opacity: 1,
        y: 0,
        transition: { duration: 0 }
      });
      await controls.start({
        opacity: 0,
        y: -10,
        transition: { duration: 0.3 }
      });
    }
    setVideoLink(videoUrl);
    setPosterLink(posterUrl);
    if (canPlay) {
      await controls.start({
        opacity: 0,
        y: 10,
        transition: { duration: 0 }
      });
      await controls.start({
        opacity: 1,
        y: 0,
        transition: { duration: 0.3 }
      });
    }
  };
  const playVideo = () => {
    var _a;
    (_a = videoRef == null ? void 0 : videoRef.current) == null ? void 0 : _a.play();
    setPlaying(true);
  };
  const pauseVideo = () => {
    var _a;
    (_a = videoRef == null ? void 0 : videoRef.current) == null ? void 0 : _a.pause();
    setPlaying(false);
  };
  const handleEnd = () => {
    var _a;
    (_a = videoRef == null ? void 0 : videoRef.current) == null ? void 0 : _a.load();
    setPlaying(false);
  };
  return /* @__PURE__ */ jsxs(VideoContainer, { className: "brandclub_video", animate: controls, children: [
    /* @__PURE__ */ jsx(
      "div",
      {
        className: `video_control ${playing ? "playing" : "paused"} ${lowerPlaybutton ? "lower" : ""}`,
        onClick: () => {
          if (canPlay) {
            if (!playing) {
              playVideo();
            } else {
              pauseVideo();
            }
          }
        },
        children: canPlay ? !playing ? /* @__PURE__ */ jsx("button", { className: `control_button play `, children: /* @__PURE__ */ jsx(
          "img",
          {
            loading: "lazy",
            className: "play_button",
            src: "https://media.brandclub.com/brandclub/image_asset/video_play.svg",
            alt: "play"
          }
        ) }) : /* @__PURE__ */ jsx("button", { className: `control_button pause`, children: /* @__PURE__ */ jsx(
          "img",
          {
            loading: "lazy",
            className: "pause_button",
            src: "https://media.brandclub.com/brandclub/image_asset/video_pause.svg",
            alt: "pause"
          }
        ) }) : null
      }
    ),
    /* @__PURE__ */ jsx(
      "video",
      {
        ref: videoRef,
        src: videoLink,
        playsInline: true,
        controls: false,
        style: { background: "white", display: "block", position: fixContainer ? "absolute" : "relative" },
        className: "video_content",
        poster: posterLink,
        onPlay,
        onPause: (event) => {
          if (!playing) {
            onPause({ currentTime: event.currentTarget.currentTime });
          }
        },
        onEnded: (event) => {
          onEnd({ duration: event.currentTarget.duration });
          handleEnd();
        }
      }
    )
  ] });
};
export {
  BrandclubVideo
};
//# sourceMappingURL=BrandclubVideo.js.map
